import {useState} from 'react'
import {useFranchiseTransferCart} from '../core/FranchiseTransferProvider'
import {FTPaymentClientOriginModal} from './FTPaymentClientOriginModal'
import {FTPaymentClientDestinationModal} from './FTPaymentClientDestinationModal'
import {formatMonetaryToBr} from '../../../../../utils/formatMonetaryToBr'
import {KTIcon} from '../../../../../_metronic/helpers'

export const FTChoicePayment = ({formik}) => {
  const {dataCalculate, setHiddenButton, valueOrigin, valueDestination} = useFranchiseTransferCart()
  const [openPaymentClientOriginModal, setOpenPaymentClientOriginModal] = useState(false)
  const [openPaymentClientDestinationModal, setOpenPaymentClientDestinationModal] = useState(false)

  return (
    <>
      {openPaymentClientOriginModal && (
        <>
          <FTPaymentClientOriginModal
            close={() => {
              setOpenPaymentClientOriginModal(false)
              setHiddenButton(false)
            }}
            formik={formik}
            data={valueOrigin}
          />
        </>
      )}

      {openPaymentClientDestinationModal && (
        <FTPaymentClientDestinationModal
          close={() => {
            setOpenPaymentClientDestinationModal(false)
            setHiddenButton(false)
          }}
          formik={formik}
          data={valueDestination}
        />
      )}

      {!openPaymentClientOriginModal && !openPaymentClientDestinationModal && (
        <>
          <div className='container'>
            <div className='card-body pt-9 pb-0'>
              <div className='card-body py-7'>
                <div className='row align-items-center mb-4'>
                  <div className='col'>
                    <h1>Entre unidades</h1>
                    <div className='col-5 text-center fs-3 fw-bold mt-3'>
                      Valor total repasse:{' '}
                      {formatMonetaryToBr(dataCalculate?.franchiseTransferValue)}
                    </div>
                  </div>
                </div>

                <div className='row align-items-center mt-12'>
                  <div className='col'>
                    <h1>Cliente</h1>
                    <div className='row align-items-center mt-3'>
                      <div className='col-6 text-center fs-3 fw-bold'>
                        Valor devido Origem: {formatMonetaryToBr(valueOrigin)}
                        {formik.errors?.billingsOrigin ? (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors?.billingsOrigin}</div>
                          </div>
                        ) : (
                          <KTIcon iconName='check' className='text-success fs-2' />
                        )}
                      </div>

                      <div className='col text-end'>
                        <button
                          className='btn bg-redlaser text-white'
                          type='button'
                          disabled={valueOrigin != 0 ? false : true}
                          onClick={() => {
                            setOpenPaymentClientOriginModal(true)
                            setHiddenButton(true)
                          }}
                        >
                          Selecionar Pagamento
                        </button>
                      </div>
                    </div>

                    <div className='row align-items-center mt-3'>
                      <div className='col text-center fs-3 fw-bold'>
                        Valor devido Destino: {formatMonetaryToBr(valueDestination)}
                        {formik.errors?.billingsDestination ? (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              {formik.errors?.billingsDestination}
                            </div>
                          </div>
                        ) : (
                          <KTIcon iconName='check' className='text-success fs-2' />
                        )}
                      </div>

                      <div className='col-6 text-end'>
                        <button
                          className='btn bg-redlaser text-white'
                          type='button'
                          disabled={valueDestination != 0 ? false : true}
                          onClick={() => {
                            setOpenPaymentClientDestinationModal(true)
                            setHiddenButton(true)
                          }}
                        >
                          Selecionar Pagamento
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}
